// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gtlCC","content":"styles_content__vWIcY","card":"styles_card__BWUaN","footer":"styles_footer__TAmWS"};